import {
  IRequirementResponse,
  RequirementExpirationStatus
} from "@wingspanhq/payments/dist/interfaces";

export const selectorExpiredRequirements = (
  requirements: IRequirementResponse[]
) =>
  requirements.filter(
    e => e.expirationStatus === RequirementExpirationStatus.Expired
  );
